export default function Scroll(config = {}) {
  return {
    target: config.target ?? null,
    offset: Number(config.offset ?? 0),
    behavior: config.behavior ?? 'auto',
    largeScreenMinWidth: Number(config.largeScreenMinWidth ?? 1024),

    init() {
      if (!this.target) {
        this.target = this.$el.dataset.scrollTarget || this.$el.getAttribute('href');
      }
    },

    scroll(customTarget = null, customOffset = null) {
      const selector = customTarget || this.target;
      const target = this.getTarget(selector);

      if (!target) {
        return;
      }

      const header = document.querySelector('header');
      const headerHeight = this.getHeaderHeight(header);
      const headerOffset = this.getHeaderOffset(header, target);
      const offset = Number(customOffset ?? this.offset);

      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerHeight - headerOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: this.getScrollBehavior()
      });
    },

    getTarget(selector) {
      if (!selector) {
        return document.body;
      }

      if (selector instanceof HTMLElement) {
        return selector;
      }

      if (typeof selector === 'string' && selector.startsWith('#')) {
        return document.getElementById(selector.slice(1));
      }

      try {
        return document.querySelector(selector);
      } catch (error) {
        return null;
      }
    },

    getHeaderHeight(header) {
      const storeHeaderHeight = Number(window.store?.headerHeight);

      if (Number.isFinite(storeHeaderHeight)) {
        return storeHeaderHeight;
      }

      return header?.offsetHeight ?? 0;
    },

    getHeaderOffset(header, target) {
      const isLargeScreen = window.matchMedia(
        `(min-width: ${this.largeScreenMinWidth}px)`
      ).matches;

      if ((header && !header.classList.contains('scrolled')) || target === document.body) {
        return isLargeScreen ? 0 : -60;
      }

      return 20;
    },

    getScrollBehavior() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      return reduceMotion ? 'auto' : this.behavior;
    }
  };
}
